import { styled } from '@linaria/react';
import { motion, MotionProps } from 'framer-motion';

interface Props extends MotionProps {
  ref?: React.Ref<HTMLDivElement>;
  primary?: boolean;
  layout?: boolean;
  style?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
  textWrapperStyle?: React.CSSProperties;
}

function Item({
  ref,
  primary,
  layout = true,
  style = {},
  wrapperStyle = {},
  textWrapperStyle = {},
  children,
  ...delegated
}: Props) {
  return (
    <Wrapper
      ref={ref}
      layout={layout}
      initial={{ borderRadius: 4 }}
      style={{
        background: primary
          ? 'hsl(50deg 100% 90%)'
          : 'var(--color-gray-500)',
        ...style,
      }}
      {...delegated}
    >
      <InnerWrapper
        layout={layout}
        initial={{ borderRadius: 2 }}
        style={{
          color: primary ? 'black' : 'var(--color-text)',
          background: primary
            ? 'hsl(50deg 100% 50%)'
            : 'var(--color-gray-100)',
          ...wrapperStyle,
        }}
      >
        <motion.span
          layout={layout}
          style={{ display: 'inline-block', ...textWrapperStyle }}
        >
          {children}
        </motion.span>
      </InnerWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  position: relative;
  display: flex;
  font-size: 1rem;
  padding: 2px;
  margin: 2px;
  transition: opacity 400ms;
  will-change: opacity;
  animation: fadeFromTransparent 400ms;
`;

const InnerWrapper = styled(motion.div)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  font-family: var(--font-family-mono);
`;

export default Item;
